window.navigator.userAgent = 'react-native';
